import api from "../api/api_settings";


export default {
    install(Vue) {
        Vue.prototype.$api = api
    },
}